//
//
//
//
//
//

import { userProjectRoles, userRoles } from '@/server/constants'

const userRolesBoth = userRoles.participant + userRoles.projectowner

export default {
  name: 'NavProjectMobile',
  data () {
    return {
      // mirrors NavSecondary (the desktop sidebar) so both project menus match
      projectNavItems: [
        { page: 'details', security: userRolesBoth },
        { page: 'questions', security: userRolesBoth },
        { page: 'requirements', security: userRoles.projectowner },
        { page: 'participants', security: userRoles.projectowner },
        { page: 'properties', security: userRolesBoth },
        { page: 'delegates', security: userProjectRoles.delegator }
      ]
    }
  }
}
